// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"18":"55698137","670":"75b44815","2965":"e78f9c2c","5897":"e2a5a5bd","7293":"530f18fb"}[chunkId] + ".chunk.css";
};